import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { SiteModeProvider, useSiteMode } from "./context/SiteModeContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import WhatWeDoSection from "./components/WhatWeDoSection";
import ExperienceSection from "./components/ExperienceSection";
import PortfolioSection from "./components/PortfolioSection";
import PhilosophySection from "./components/PhilosophySection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import PortfolioIntroPage from "./components/PortfolioIntroPage";

const LandingPage = () => {
  const { features } = useSiteMode();

  return (
    <div className="min-h-screen bg-zinc-950">
      <Header />
      <main>
        <HeroSection />
        {features.services && <WhatWeDoSection />}
        {features.experience && <ExperienceSection />}
        {features.portfolio && <PortfolioSection />}
        {features.philosophy && <PhilosophySection />}
        {features.discovery && <ContactSection />}
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <SiteModeProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/portfolio-intro" element={<PortfolioIntroPage />} />
            </Routes>
          </BrowserRouter>
        </div>
      </SiteModeProvider>
    </LanguageProvider>
  );
}

export default App;
